import { render } from "./CardDeck.vue?vue&type=template&id=0a5cd448&ts=true"
import script from "./CardDeck.vue?vue&type=script&lang=ts"
export * from "./CardDeck.vue?vue&type=script&lang=ts"

import "./CardDeck.vue?vue&type=style&index=0&id=0a5cd448&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__